import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import CancelIcon from "../../../assets/icons/cross-bold-icon.png";
import GlobalButton from "../../../components/button";
import ImageUploader from "../../../components/imageUploader";
import Label from "../../../components/label";
import AppLoader from "../../../components/loader";
import TextInput from "../../../components/textInput/index";
import { createAgent, updateAgent } from "../../../services/AgentApi";
import {
  decryptPassword,
  encryptPassword,
  handleApiCall,
} from "../../../utils/helper";
import { registerAdminValidation } from "../../../utils/Validation";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "600px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));
let paramsData = {};

const AddEditAdminitratorDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState({
    image: null,
    username: "",
    email: "",
    contact: "",
    password: "",
    confirmPassword: "",
  });

  const [inputError, setInputError] = useState({
    image: false,
    username: false,
    email: false,
    isValidEmail: false,
    contact: false,
    password: false,
    confirmPassword: false,
    isPasswordMatch: false,
  });

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
      if (params.type == "edit") {
        let editPassword = decryptPassword(params.data.encrypted);
        setInputValue({
          image: params.data.image,
          username: params.data.username,
          email: params.data.email,
          contact: params.data.contact,
          password: editPassword,
          confirmPassword: editPassword,
        });
      }
    },
    disable() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setInputValue({});
    setInputError({});
  };

  const handleSetImage = (url) => {
    setInputValue((preValue) => ({ ...preValue, image: url }));
    setInputError((preError) => ({ ...preError, image: false }));
  };

  const handleChangeValue = (event) => {
    const { name, value } = event.target;
    setInputError((preError) => ({
      ...preError,
      [name]: false,
      isValidEmail: name === "email" ? false : inputError.isValidEmail,
      isPasswordMatch:
        name === "confirmPassword" ? false : inputError.isPasswordMatch,
    }));
    setInputValue((preValue) => ({ ...preValue, [name]: value }));
  };

  const addEditAgents = () => {
    const validate = registerAdminValidation(inputValue, setInputError);
    if (validate) {
      return;
    }

    let encryptedPass = encryptPassword(inputValue.password);

    let payload = {
      ...inputValue,
      password: encryptedPass,
      designation: "Admin",
      dailyTarget: 0,
      sellsTarget: 0,
    };

    if (paramsData.type == "add") {
      handleApiCall(
        "",
        createAgent,
        payload,
        setIsLoading,
        handleClose,
        paramsData.getData,
      );
    } else {
      handleApiCall(
        paramsData.data._id,
        updateAgent,
        payload,
        setIsLoading,
        handleClose,
        paramsData.getData,
      );
    }

    // const payload = {};
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <Stack
          p={2}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography
            variant="h1"
            fontSize={"1.5rem"}
            fontWeight={500}
            color={"secondary.dark"}
          >
            {paramsData.type === "add" ? "Add Admin" : "Edit Admin"}
          </Typography>
          <IconButton onClick={handleClose}>
            <img src={CancelIcon} alt="cancel-icon" width={25} />
          </IconButton>
        </Stack>
        <DialogContent dividers>
          <ImageUploader
            image={inputValue.image}
            isError={inputError.image}
            setIsLoading={setIsLoading}
            setImage={handleSetImage}
          />
          <Box component={"form"} maxWidth={500} margin={"auto"}>
            <Grid container spacing={2} my={3}>
              <Grid item xs={12}>
                <Label title={"Admin Name"} required htmlFor={"admin-name"} />
                <TextInput
                  id={"admin-name"}
                  type={"text"}
                  required
                  error={inputError.username}
                  helperText={inputError.username && "Admin name is required"}
                  defaultStyle={true}
                  placeholder={"Enter admin name"}
                  value={inputValue.username}
                  name={"username"}
                  onChange={handleChangeValue}
                />
              </Grid>
              <Grid item xs={12}>
                <Label title={"Admin Email"} required htmlFor={"admin-email"} />
                <TextInput
                  id={"admin-email"}
                  type={"email"}
                  required
                  error={inputError.email || inputError.isValidEmail}
                  helperText={
                    inputError.email
                      ? "Email is required"
                      : inputError.isValidEmail
                        ? "Invalid email format"
                        : null
                  }
                  defaultStyle={true}
                  placeholder={"Enter agent email"}
                  value={inputValue.email}
                  name={"email"}
                  onChange={handleChangeValue}
                />
              </Grid>
              <Grid item xs={12}>
                <Label
                  title={"Admin Contact"}
                  required
                  htmlFor={"admin-contact"}
                />
                <TextInput
                  id={"admin-contact"}
                  type={"number"}
                  required
                  error={inputError.contact}
                  helperText={inputError.contact && "Contact is required"}
                  defaultStyle={true}
                  placeholder={"Admin contact"}
                  value={inputValue.contact}
                  name={"contact"}
                  onChange={handleChangeValue}
                />
              </Grid>

              <Grid item xs={12}>
                <Label
                  title={"Set Password"}
                  required
                  htmlFor={"agent-password"}
                />
                <TextInput
                  id={"agent-password"}
                  type={"text"}
                  required
                  error={inputError.password}
                  helperText={inputError.password && "Password is required"}
                  defaultStyle={true}
                  placeholder={"Enter password"}
                  value={inputValue.password}
                  name={"password"}
                  onChange={handleChangeValue}
                />
              </Grid>
              <Grid item xs={12}>
                <Label
                  title={"Re-Password"}
                  required
                  htmlFor={"confirm-agent-password"}
                />
                <TextInput
                  id={"confirm-agent-password"}
                  type={"text"}
                  required
                  error={
                    inputError.confirmPassword || inputError.isPasswordMatch
                  }
                  helperText={
                    inputError.confirmPassword
                      ? "Re-enter passoword is required"
                      : inputError.isPasswordMatch
                        ? "Password is not matched"
                        : null
                  }
                  defaultStyle={true}
                  placeholder={"Re-enter password"}
                  value={inputValue.confirmPassword}
                  name={"confirmPassword"}
                  onChange={handleChangeValue}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <GlobalButton
            variant={"custom_gradient"}
            handleClickBtn={addEditAgents}
            title={
              paramsData.type === "add" ? "Create New Admin" : "Edit Admin"
            }
          />
        </DialogActions>
      </BootstrapDialog>
    </>
  );
});

export default AddEditAdminitratorDialog;
